import Chart from 'chart.js/auto';
import def_day_lines from './graph_utils.js';

export default function graph_flux_solaire(ser,dates,ff2d,delta){

  var ff = new Array(ff2d.length-1);
  var ff2 = new Array(ff2d.length-1);
  var dates2 = new Array(ff2d.length-1);
  var ann = [];
  // Note les donnees sont en Joule/m2 accumulees depuis le debut.
  // On calcul le nombre de watt/m2 moyen dans l'interval de temps.
  // (data1[i]-data1[i-1]) = nombre de Joule/m2 dans l'interval
  // 3600*delta            = nombre de seconde dans l'enterval
  // Le rappor des deux donne le montre de watt/m2 moyen
  for(let i=0; i < ff.length; i++){
    ff[i]=ff2d[i][0];
    // L'accumulation des flux n'est pas monotone.
    ff2[i]=Math.max(parseInt(ff2d[i+1][1])-parseInt(ff2d[i][1]),0.)/(3600.*delta);
    dates2[i]=dates[i];
  }

  var label="Flux solaire moyen dans l'heure indiquée sur l'axe des x";
  if(parseInt(delta) > 1){
    label="Flux solaire moyen dans les "+String(delta)+" heures suivant l'heure indiquée sur l'axe des x";
  }
  
  const dt = {
    labels: dates2,
    datasets: [
      {
	label: label,
	data: ff2,
	backgroundColor: 'rgb(235, 143, 52)',
	order: 1,
	yAxisID: 'y',
      },
      {
	label: 'Couver nuageux',
	data: ff,
	borderColor: 'rgb(52, 85, 235)',
	type: 'line',
	lineTension: 0.3,
	order: 0,
	yAxisID: 'y1',
      }
    ]    
  };

  def_day_lines(dates,ann);
 
  const ctx = document.getElementById('id_series_canvas');
  if(ser.chart){
    ser.chart.destroy();
  }
  ser.chart = new Chart(ctx, {
    type: 'bar',
    data: dt,
    options: {
      maintainAspectRatio: false,
      animations: false,
      responsive: true,
      scales: {
	y: {
          type: 'linear',
          display: true,
          position: 'left',
	  title: {
	    display: true,
	    text: 'Flux solaire [W/m^2]'
	  },
	  suggestedMax: 900
	},
	y1: {
          type: 'linear',
          display: true,
          position: 'right',
	  title: {
	    display: true,
	    text: 'Couver nuageux [%]'
	  },
          // grid line settings
          grid: {
            drawOnChartArea: false, // only want the grid lines for one axis to show up
          },
	  min: 0,
	  max: 100
	}
      },
      plugins: {
	annotation: {
	  annotations: ann
	},	
	zoom: {
	  zoom: {
	    wheel: {
	      enabled: true
	    },
	    pinch: {
	      enabled: true
	    },
	    mode: "x",
	    speed: 100				    
	  },
	  pan: {
	    enabled: true,
	    mode: "x",
	    speed: 100
	  }
	}
      }
    }
  });
}

